import requests from "./http";

class ProductService {
  getItemDetails(payload) {
    return requests.post(`/product-detail`, payload);
  }

}

export default new ProductService();